<div class="method-choice">
  <div class="method-choice__cards">
    <button *ngFor="let m of methods; trackBy: trackByType"
            type="button"
            class="method-choice__card"
            [class.method-choice__card_active]="m.type === selectedType"
            (click)="choose(m.type)">
      <span class="method-choice__icon"
            [class.method-choice__icon_card]="m.icon === 'bank-card'"
            [class.method-choice__icon_case]="m.icon === 'case'"
            [class.method-choice__icon_test]="m.icon === 'test'"></span>
      <span class="method-choice__name">{{ m.label }}</span>
    </button>
  </div>
</div>
